export enum LabelDisplayOptionsEnum {
    percent = 'percent',
    count = 'count'
}
